import React, { useRef } from 'react';
import Modal from '../Modal';
import './LoginModal.scss';
import Image from '../Image';
// import { learning_group_img, login_logo } from './constant';
import { login_logo } from './constant';
import LoginForm from './partials/LoginForm';
import { useAuthContext } from '../../contexts/AuthContext';

function LoginModal() {
  const {
    openLoginModal,
    toggleLoginModal,
    login,
    isLoading,
    loginError,
    resetLoginError,
  } = useAuthContext();
  const className = 'c-LoginModal';
  const formRef = useRef(null);

  function onSubmit(e) {
    e.preventDefault();
    let email = formRef.current.email.value;
    let password = formRef.current.password.value;
    login(email, password);
  }

  function onChange() {
    if (loginError) resetLoginError();
  }

  if (!openLoginModal) return null;

  return (
    <div className={className}>
      <Modal
        open={openLoginModal}
        onClose={toggleLoginModal}
        customBaseClass={`${className}`}
      >
        <div className={`${className}__logo__wrapper`}>
          <Image {...login_logo} />
        </div>
        <div className={`${className}__subtext`}>
          Login For a Peek Into the World of People
        </div>
        <LoginForm
          error={loginError}
          onChange={onChange}
          onSubmit={onSubmit}
          isLoading={isLoading}
          formRef={formRef}
        />
        {/* <div className={`${className}__img__wrapper`}>
          <Image {...learning_group_img} />
        </div> */}
      </Modal>
    </div>
  );
}

export default LoginModal;
